"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index.vue"));
var _user = require("@/api/user");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'explainCreat',
  components: {
    Tinymce: _index.default
  },
  props: {
    //是否显示隐藏
    drawerVisible: {
      type: Boolean,
      default: false
    },
    pramInfo: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    this.pram = Object.assign({}, this.pramInfo);
  },
  data: function data() {
    return {
      pram: {
        expand: '',
        id: 0,
        name: ''
      }
    };
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleClose: function handleClose() {
      this.$emit('onClosedrawerVisible');
    },
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.pram.validate(function (valid) {
        if (valid) {
          (0, _user.memberBenefitsStatementEditApi)(_this.pram).then(function (response) {
            _this.$modal.msgSuccess('保存成功');
            _this.$emit('subSuccess');
          });
        }
      });
    }
  }
};